var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          attrs: {
            name: "basic-t",
            title: _vm.dialogTitle,
            "close-on-click-modal": _vm.closeOnClickModal1,
            modal: true,
            width: 560,
            height: 204,
            confirmButtonText: _vm.suredown,
            "append-to-body": "",
          },
          on: {
            confirm: _vm.handleConfirm,
            "after-close": _vm.handleAfterClose,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [_vm._v(" 确定要开始下载文件(ID:" + _vm._s(_vm.UseId) + ")吗？ ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }